<template>
	<main class="new-edit-teacher">
		<el-form
			:model="model"
			ref="theForm"
			label-width="100px"
			:rules="validationRules"
			@submit.native.prevent="createUpdateTeacher"
		>
			<el-divider content-position="left">
				<span style="color: #c0c4cc;">登录信息</span>
			</el-divider>

			<el-form-item label="登录名" prop="account.login_name">
				<el-input v-model="model.account.login_name" placeholder="用于登录" />
			</el-form-item>

			<el-form-item ref="account-pass1" label="密码" prop="account.pass1">
				<el-input
					@focus="$refs['account-pass1'].clearValidate()"
					type="password"
					v-model="model.account.pass1"
					autocomplete="off"
					:placeholder="$route.params.id ? '留空保持不变' : '请输入账号密码'"
				></el-input>
			</el-form-item>

			<el-form-item ref="account-pass2" label="确认密码" prop="account.pass2">
				<el-input
					@focus="confirmPassFocus"
					type="password"
					v-model="model.account.pass2"
					autocomplete="off"
					:placeholder="$route.params.id ? '留空保持不变' : '请再次输入密码以确认'"
				></el-input>
			</el-form-item>

			<el-divider content-position="left">
				<span style="color: #c0c4cc;">教师信息</span>
			</el-divider>

			<el-form-item label="学校" prop="school_id" v-if="canPickSchool">
				<load-select
					v-model="model.school_id"
					:placeholder="'请选择学校'"
					:options="schoolsPickable"
					:paginate="schoolListPaginate"
					:request="refreshSchoolList"
					@change="onSchoolPicked"
				></load-select>
			</el-form-item>

			<el-form-item label="学科" prop="subject_id" ref="subject">
				<el-select v-model="model.subject_id" placeholder="请选择学科">
					<el-option v-for="item in subjectsPickable" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="科目长">
				<el-checkbox v-model="model.is_supervisor"></el-checkbox>
			</el-form-item>

			<el-form-item label="职工编号" prop="account.serial">
				<el-input v-model="model.account.serial" />
			</el-form-item>

			<el-form-item label="真实姓名" prop="account.realname">
				<el-input v-model="model.account.realname" />
			</el-form-item>

			<el-divider content-position="left">
				<span style="color: #c0c4cc;">其他</span>
			</el-divider>

			<el-form-item ref="account-mobile" label="手机号" prop="account.mobile">
				<el-input @focus="mobileFocus" v-model="model.account.mobile" />
			</el-form-item>

			<el-form-item label="头像" prop="account.avatar">
				<oss-uploader
					:limit="1"
					accept="image/*"
					:on-change="refreshUpFileList"
					:on-remove="refreshUpFileList"
					:show-file-list="false"
					@is-uploading="isUploading"
					ref="avatar"
				>
					<el-avatar
						shape="square"
						class="personal-avatar"
						v-if="model.account.avatar"
						:size="134"
						:src="model.account.avatar"
						:error="
							() => {
								return false
							}
						"
					/>
					<i v-else class="el-icon-plus uploadBox"></i>
				</oss-uploader>
			</el-form-item>

			<el-form-item>
				<el-button :disabled="isAnyUploading" v-if="$route.params.id" type="primary" native-type="submit"
					>更新</el-button
				>
				<el-button :disabled="isAnyUploading" v-else type="primary" native-type="submit">创建</el-button>
			</el-form-item>
		</el-form>
	</main>
</template>
<script>
export default {
	data() {
		return {
			isAnyUploading: false,
			model: {
				account: {
					avatar: null
				},
				is_supervisor: false
			},
			avatar: null,
			schoolsPickable: [],
			subjectsPickable: [],
			validationRules: {
				school_id: [
					{
						required: true,
						message: '请选择学校',
						trigger: 'change'
					}
				],
				subject_id: [
					{
						required: true,
						message: '请选择学科',
						trigger: 'change'
					}
				],
				'account.login_name': [
					{
						required: true,
						message: '请输入登录名',
						trigger: 'change'
					}
				],
				'account.realname': [
					{
						required: true,
						message: '请输入真实姓名',
						trigger: 'change'
					}
				],
				'account.pass1': [
					{
						required: !this.$route.params.id,
						validator: (rule, value, callback) => {
							if (rule.required && !value) {
								callback(new Error('请输入密码'))
								return
							}
							if (this.model.account.pass2 && !value) {
								callback(new Error('请输入密码'))
							} else {
								this.$refs.theForm.validateField('account.pass2')
								callback()
							}
						},
						trigger: 'change'
					}
				],
				'account.pass2': [
					{
						required: !this.$route.params.id,
						validator: (rule, value, callback) => {
							if (rule.required && !value) {
								callback(new Error('请输入密码'))
								return
							}
							if (!value && this.model.account.pass1) {
								callback(new Error('请再次输入密码'))
							} else if (this.model.account.pass1 && value !== this.model.account.pass1) {
								callback(new Error('两次输入密码不一致!'))
							} else {
								callback()
							}
						},
						trigger: 'change'
					}
				],
				'account.mobile': [
					{
						validator: (rule, value, callback) => {
							if (value) {
								const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
								if (reg.test(value)) {
									callback()
								} else {
									return callback(new Error('请输入正确的手机号'))
								}
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				]
			},
			schoolListPaginate: {
				page: 1,
				size: 20,
				last_page: null
			}
		}
	},
	computed: {
		canPickSchool() {
			return (
				this.$store.state.user.userInfo.type == this.$api.account.types.BUREAU_ADMIN.value ||
				this.$store.state.user.userInfo.type == this.$api.account.types.PLATFORM_ADMIN.value
			)
		}
	},
	async created() {
		// debugger
		if (this.$route.params.id) {
			// 编辑模式
			this.model = await this.$api.teacher.show(this.$route.params.id)
			let school = await this.$api.school.show(this.model.school_id)
			this.schoolsPickable = [school]
			this.$emit('breadcrumbChange', [
				{
					name: '编辑',
					to: null
				}
			])
		} else {
			this.$emit('breadcrumbChange', [
				{
					name: '新建',
					to: null
				}
			])

			if (this.$store.state.user.userInfo.type == this.$api.account.types.SCHOOL_ADMIN.value) {
				this.model.school_id = this.$store.state.user.userInfo.school_admin.school_id
			}
		}

		if (this.canPickSchool) {
			// 可选的学校
			this.refreshSchoolList(this.schoolListPaginate)
		}

		//可选学科
		this.refreshClassgradeAvailable()
	},
	methods: {
		async refreshSchoolList(paginate, more, keyword) {
			let resSg
			switch (this.$store.state.user.userInfo.type) {
				case this.$api.account.types.BUREAU_ADMIN.value:
					resSg = await this.$api.school.list({
						admin_scope: this.$store.state.user.userInfo.bureau_admin.bureau.admin_scope,
						paginate: paginate,
						fu_name: keyword
					})
					break
				case this.$api.account.types.PLATFORM_ADMIN.value:
					resSg = await this.$api.school.list({
						paginate: paginate,
						fu_name: keyword
					})
					break
			}
			this.schoolListPaginate.page = resSg.meta.current_page
			this.schoolListPaginate.last_page = resSg.meta.last_page
			// 如果是加载更多，则合并之前的数据
			this.schoolsPickable = more ? [...this.schoolsPickable, ...resSg.data] : resSg.data
		},
		onSchoolPicked() {
			if (!this.model.school_id) {
				this.subjectsPickable = []
				this.model.subject_id = null
				return
			}
			this.refreshClassgradeAvailable()
		},
		async refreshClassgradeAvailable() {
			if (this.model.school_id) {
				let res = await this.$api.school.show(this.model.school_id)
				this.subjectsPickable = res.subjects
			}
		},
		mobileFocus() {
			this.$nextTick(() => {
				this.$refs['account-mobile'].clearValidate()
			})
		},
		confirmPassFocus() {
			this.$nextTick(() => {
				this.$refs['account-pass2'].clearValidate()
			})
		},
		isUploading(value) {
			this.isAnyUploading = value
		},
		refreshUpFileList(file, fileList) {
			if (file.percentage >= 100) {
				this.model.account.avatar = file.raw.net_url
				this.model.account.avatar_key = file.raw.key

				// 清空uploader内部的list，否则无法再次上传
				this.$refs.avatar.clearFiles()
			}
		},
		createUpdateTeacher() {
			this.$refs['theForm'].validate(async valid => {
				if (valid) {
					//clone一下
					let model = JSON.parse(JSON.stringify(this.model))
					model.version = 2
					if (model.account.pass1 && model.account.pass2) {
						model.account.pass1 = window.btoa(model.account.pass1)
						model.account.pass2 = window.btoa(model.account.pass2)
					}
					// if (!model.account.nickname) {
					//   model.account.nickname = model.account.realname;
					// }

					if (this.$route.params.id) {
						// 更新

						await this.$api.teacher.update(this.$route.params.id, model)
					} else {
						// 创建
						await this.$api.teacher.create(model)
					}

					// 成功后返回
					this.$router.go(-1)
				} else {
					return false
				}
			})
		}
	}
}
</script>

<style lang="scss">
.new-edit-teacher {
	padding: 30px;

	.el-input {
		width: 350px;
	}

	.uploadBox {
		padding: 60px;
		color: green;
		border: 2px dashed green;
	}
}
</style>
